import { ROLES } from "./Acl";
import { AnswerItem } from "./AnswerItem";
import { Checklist } from "./Checklist";
import { DealerID } from "./Dealer";
import { DealerLocationID } from "./DealerLocation";
import { QuestionResultImage, QuestionResultVideo } from "./QuestionResult";
import { Tag, TagID } from "./Tag";

export type QuestionGroupID = number;

export type QuestionID = number;

export type QuestionElementID = number;

export type QuestionsQuestionElementsID = number;

export enum QUESTION_OPTIONS {
  PriceEnabled = 1,
  SnoozeEnabled = 2,
  PinEnabled = 3,
  DisableOkWithoutNote = 4,
  HideXButton = 5,
  PhotoMandatory = 6,
  HideCustomerOkAndConvertToIntervention = 7
}

export enum QUESTION_ELEMENT_TEMPLATES {
  Dropdown = "dropdown",
  DropdownMulti = "dropdown_multi",
  Solution = "solution_element",
  TextField = "textfield",
  Number = "number",
  Textarea = "textarea",
  Spinner = "spinner",
  DatePicker = "datepicker",
  Tyre = "tyre",
  Panic = "panic",
  TestDriveMileage = "testdrive_mileage",
  EmployeeSignature = "employee_signature",
  CustomerSignature = "customer_signature",
  TruckTyre = "truck_tyre",
  Timestamp = "timestamp",
  HeavyVanTyre = "heavy_van_tyre",
  TyreSeason = "tyre_season",
  TyreDropdowns = "tyre_dropdowns",
  TyreSpinner = "tyre_spinner",
  TyreRemark = "tyre_remark",
  TyreAlignment = "tyre_alignment"
}

export interface QuestionGroup {
  created_on: string;
  updated_on: string;
  id: QuestionGroupID; // Claire Question Group ID
  name: string; // Name of the group of question
  ordering: number; // Ordering of the group of question
  questions?: Question[]; // List of questions in this group
}

export interface Question {
  created_on: string;
  updated_on: string;
  id: QuestionID; // Claire Question ID
  title?: string; // Title of the question
  active: boolean;
  ordering: number;
  role_id: ROLES; // NULL if it is a default question available to all, otherwise the role ID of the user who created this question (meaning it is only visible to that Dealer's locations)
  default_status: number;
  can_duplicate: boolean;
  evhc_labor_percent: number; // Labor percentage to the total cost, sum <=100
  evhc_part_percent: number; // Part percentage to the total cost, sum <=100
  evhc_tire_percent: number; // Tire percentage to the total cost, sum <=100
  evhc_external_percent: number; // External percentage to the total cost, sum <=100
  is_deleted: boolean;
  dealer_id: DealerID | null;
  dealer_location_id: DealerLocationID;
  question_elements?: QuestionElement[]; // List of question element in this question
  checklist?: Checklist[];
  tag_ids?: TagID[];
  tags?: Tag[];
  contains_tyre_element?: boolean;
  question_options?: QuestionOption[];
  default_images?: QuestionResultImage[];
  default_videos?: QuestionResultVideo[];
}

export interface QuestionElement {
  id: QuestionElementID; // Claire Question Element ID
  created_on: string;
  updated_on: string;
  name: string; // Name of the question element
  ordering: number;
  template: QUESTION_ELEMENT_TEMPLATES; // Template of the question element, define what type of answer will be provided, refer to that enumeration for more details
  default_configuration: string; // Default configuration, depending on the template can contain prefilled values or labels
  role_id: ROLES; // NULL if it is a default question element available to all, otherwise the role ID of the user who created this question element (meaning it is only visible to that Dealer's locations)
  default_answer?: AnswerItem;
}

export interface QuestionsQuestionElements {
  id: QuestionsQuestionElementsID;
  ordering: number;
  default_configuration: string;
  question_id: QuestionID;
  question_element_id: QuestionElementID;
}

export interface QuestionOption {
  id: QUESTION_OPTIONS;
  name: string;
  value: boolean;
}
